/**
 * 绘制标签
 *
 * @param {HTMLCanvasElement} canvas 绘制的画布
 * @param {Stirng} text 文本
 * @param {Stirng} textColor 文本颜色
 * @param {Stirng} backgroudColor 背景颜色
 */
function drawRoundText (canvas, text, textColor, backgroudColor) {
  const tc = textColor || 'rgba(255,255,255, .85)'
  const bc = backgroudColor || 'rgba(0,0,0,.4)'
  const context = canvas.getContext('2d')
  context.font = '100px Arial'

  const offset = 70
  const textLen = context.measureText(text)
  const rectLen = textLen.width + 60 + offset
  const canvasLen = rectLen + 4

  context.canvas.width = canvasLen
  context.canvas.height = 168

  context.beginPath()
  context.moveTo(1 + 30, 1)
  context.lineWidth = 1
  context.strokeStyle = bc
  context.fillStyle = bc
  context.arcTo(3 + rectLen, 1, 3 + rectLen, 1 + 142, 30)
  context.arcTo(3 + rectLen, 1 + 142, 1, 1 + 142, 30)
  context.arcTo(1, 1 + 142, 1, 1, 30)
  context.arcTo(1, 1, 3 + rectLen, 1, 30)
  context.stroke()
  context.fill()
  context.closePath()

  context.font = 'Bold 100px Arial'
  context.textAlign = 'center'
  context.fillStyle = tc
  context.fillText(text, canvasLen / 2, 108)
}

export {
  drawRoundText
}
